import { register } from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('beauty-slider', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `#beauty-slider--${id}`;
    new Swiper(target, {
      slidesPerView: 1,
      loop: true,
      freeMode: false,
      spaceBetween: 70,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 60,
        },
        720: {
          slidesPerView: 1,
          spaceBetween: 70,
        },
      },
    });
  },
});
